import { useSettings } from "../context/SettingsContext";
import { SectionTitle } from "../components/shared";
import { Seo } from "../lib/seo";

export default function Termini() {
  const { settings } = useSettings();
  return (
    <div className="mx-auto max-w-3xl px-6 py-16">
      <Seo title="Termini e Condizioni | Herbalife Rossano" description="Condizioni di vendita del negozio online Herbalife Rossano: prezzi, IVA, tempi di spedizione e consegna." canonical="/termini" />
      <SectionTitle eyebrow="Legale" title="Termini e Condizioni" />
      <div className="mt-8 text-slate-600 leading-relaxed whitespace-pre-line">{settings?.terms_text}</div>
    </div>
  );
}
